import React, { Component, PropTypes } from 'react'
import styles from './index.css'
import Close from '../Close'
import headerImage from './barner.png'
import config from 'config'

class Subscribe extends Component {
  constructor (props) {
    super(props)
    this.state = {
      username: '',
      date: '',
      time: '',
      phone: '',
      messageCode: '',       // 短信验证码
      errorInfo: '',
      imageCode: '',             // 图形验证码
      count: 60             // 倒计时
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.sendVerifyCode = this.sendVerifyCode.bind(this)
    this.toggleImage = this.toggleImage.bind(this)
    this.countdown = this.countdown.bind(this)
  }

  sendVerifyCode () {
    const { phone, imageCode, count } = this.state
    if (count !== 60) {
      return
    }
    if (!/1[3|5|7|8|][0-9]{9}/.test(phone)) {
      this.setState({
        errorInfo: '请输入合法手机号码'
      })
      return
    }
    this.setState({ errorInfo: '' })
    fetch(`${config.userService.url}/captcha/phone/jsonp?type=authenticode&phone=${phone}&captcha=${imageCode}&smartCallback=0`, {
      credentials: 'include'
    })
    .then(res => res.text())
    .then(data => {
      const json = JSON.parse(data.slice(2, -1))
      if (json.msg) {
        throw new Error(json.msg)
      }
      this.countdown()
    })
    .catch(err => {
      this.setState({
        errorInfo: err.message
      })
    })
  }

  toggleImage (e) {
    const src = e.target.src
    e.target.src = `${src}?2333=${e.timeStamp}`
  }

  countdown () {
    setTimeout(() => {
      this.setState(({ count: prevcount }) => {
        if (prevcount === 0) {
          return { count: 60 }
        }
        return { count: prevcount - 1 }
      })
      if (this.state.count !== 60 ) {
        this.countdown()
      }
    }, 1000)
  }

  handleSubmit (e) {
    const {
      username,
      phone,
      messageCode
    } = this.state
    if (!username) {
      this.setState({ errorInfo: '请填写姓名' })
      return
    }
    fetch(`${config.userService.url}/captcha/phone/check?phone=${phone}&captchaPhone=${messageCode}`, {
      credentials: 'include'
    })
    .then(res => res.json())
    .then(data => {
      if (data.code !== 0) {
        throw new Error(data.msg)
      }
      if (!data.data) {
        throw new Error('手机验证码错误')
      }
      return fetch(`${config.api.promotion}/user`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `phone=${phone}&name=${username}&source=${'ti.smartstudy.com'}&pageName=${'make-pigai-appointment'}
        &index=0&type=1&extension=${JSON.stringify({})}&repeat=1`
      })
    })
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) {
        throw new Error(json.msg)
      }else {
        this.setState({
          errorInfo: '预约批改成功'
        },()=> {
          setTimeout(()=>{
            this.props.onClose()
          },1000)
        })
      }
    })
    .catch(err => {
      this.setState({
        errorInfo: err.message
      })
    })
  }

  renderForm () {
    const {
      username,
      messageCode,       // 短信验证码
      errorInfo,
      phone,
      imageCode,             // 图形验证码
      count
    } = this.state

    return (
      <div className={styles.form}>
        <div className="row">
          <span className={styles.usericon}></span>
          <input
            type="text"
            placeholder="填写姓名，以便学习顾问与您交流"
            value={username}
            onChange={e => this.setState({ username: e.target.value })}
          />
        </div>
        <div className="row phone">
          <span className={styles.phoneicon}></span>
          <input
            type="text"
            placeholder="请输入手机号"
            value={phone}
            onChange={e => this.setState({ phone: e.target.value })}
          />
        </div>
        <div className="row code">
          <span className={styles.codeicon}></span>
          <input
            type="text"
            placeholder="请输入图形验证码"
            value={imageCode}
            onChange={e => this.setState({ imageCode: e.target.value })}
          />
          <img src={`${config.userService.url}/captcha`} alt="code" onClick={this.toggleImage} />
        </div>
        <div className="row info">
          <span className={styles.codeicon}></span>
          <input
            type="text"
            placeholder="填写验证码"
            value={messageCode}
            onChange={(e) => this.setState({ messageCode: e.target.value })}
          />
          <span
            style={count === 60 ? {} : { backgroundColor: '#aaa' }}
            className={styles.verifyButton}
            onClick={this.sendVerifyCode}
          >
            { count === 60 ? '发送验证码' : `${count}秒后重发` }
          </span>
        </div>
        <div className="error">{ errorInfo }</div>
        <span className={styles.submitButton} onClick={this.handleSubmit}>预约批改服务</span>
      </div>
    )
  }

  render () {
    const { onClose, show } = this.props

    return show && (
      <div
        className={styles.root}
        onClick={e => {
          if (e.target === e.currentTarget) {
            onClose()
          }
        }}
      >
        <div className={styles.modal}>
          <Close onChange={onClose}></Close>
          <div className={styles.header}>
            <img src={headerImage} alt="barner" width="100%" />
          </div>
          <div className={styles.body}>
            <div className={styles.title}>
              预约批改服务
            </div>
              { this.renderForm() }
          </div>
        </div>
      </div>
    )
  }
}


Subscribe.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}


export default Subscribe



/** WEBPACK FOOTER **
 ** ./src/components/Common/Subscribe/index.js
 **/